import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  ErrorOutlineOutlined as UrgentOutlined,
  Error as UrgentFilled,
} from "@material-ui/icons";
import ToolTip from "../../../../../common/StyledToolTip";
import styles from "./styles";

const Urgent = ({ classes, onClick, isMarkedAsUrgent = false }) => (
  <div className={classes.scHeaderCloseButton} onClick={onClick}>
    <ToolTip title={isMarkedAsUrgent ? "Unmark urgent" : "Mark urgent"}>
      {isMarkedAsUrgent ? (
        <UrgentFilled className={classes.scUrgentMsgFilled} />
      ) : (
        <UrgentOutlined className={classes.scUrgentMsgOutlined} />
      )}
    </ToolTip>
  </div>
);

export default withStyles(styles)(Urgent);
